import ActionTypes from "../constants/action_types";

export default function clearTopic(organisationId, topicId) {
  return {
    type: ActionTypes.TOPIC_CLEAR.SUCCESS,
    organisation_id: organisationId,
    topic_id: topicId,
  };
}
